module.exports = __webpack_public_path__ + "img/6497aca.png";